import React, { useEffect } from "react";
import { LanguageUtils } from "../../language/LanguageUtils";
import Header from "../header";

interface ViewProps{
}

const View:React.FC<ViewProps> = (props: ViewProps) => {

    useEffect(() => {
        const scriptUrl = document.createElement('script');
        scriptUrl.type = 'text/javascript';
        scriptUrl.src = '../assets/js/common.min.js';
        document.body.appendChild(scriptUrl);

        const scriptUrl2 = document.createElement('script');
        scriptUrl2.type = 'text/javascript';
        scriptUrl2.src = '../assets/js/story.min.js';
        document.body.appendChild(scriptUrl2);
    },[]);

    return(
    <>
        <title>STORY | PROJECT ZIRCON（プロジェクト ジルコン） 公式サイト</title>
        <Header />
        <div className="wrapper">
            <div className="gem_wrap back">
                <div className="gem" id="gem_back"></div>
            </div>
            <div className="gem_wrap front">
                <div className="gem" id="gem_front"></div>
            </div>
            <header id="incHd"></header>
            <main>
                <section className="subpage_header">
                    <div className="compass_wrap">
                        <p className="bg_compass"><img src="../assets/img/bg_compass_anime.svg" alt="" width="6058" height="6058"/></p>
                    </div>
                    <h2 className="ttl_deco_side">
                        <span className="en">STORY</span>
                        <span className="jp">{LanguageUtils.getLanguageData().story_story}</span>
                    </h2>
                </section>
                <section className="world_area">
                    <p className="catch" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_story_catch}}></p>
                    <h3 className="sec_ttl fadeup">
                        <span className="en">WORLD</span>
                        <span className="jp">{LanguageUtils.getLanguageData().story_world}</span>
                    </h3>
                    <div className="bg_paper fadeup">
                        <div className="map"><img src="../assets/img/story/common/world_map.jpg" alt="" width="1000" height="609"/></div>
                        <h4 className="ttl_map">
                            <span className="ja">{LanguageUtils.getLanguageData().story_orfinia}</span>
                            <span className="en"><img src="../assets/img/story/common/world_map_ttl_en.png" alt="The Continent of Orfinia" width="411" height="36"/></span>
                        </h4>
                        <picture className="txt">
                            <source srcSet={`../assets/img/story/${LanguageUtils.getLanguage()}/world_map_txt.png`} media="(min-width: 769px)"/>
                            <img src={`../assets/img/story/${LanguageUtils.getLanguage()}/world_map_txt_sp.png`} alt="百年前の「大災」で一度文明が滅びかけた大陸。大災が噴出した大穴「The Hole」近くに存在するも、驚異的な復興を遂げる。現在、四大国はそれぞれ不可侵の関係を維持しつつ、独自の発展を遂げている。" width="596" height="655"/>
                        </picture>
                    </div>
                </section>
                <section className="nations_area">
                    <div className="anc_area">
                        <div className="compass_wrap">
                            <p className="bg_compass"><img src="../assets/img/bg_compass_anime.svg" alt="" width="6058" height="6058"/></p>
                        </div>
                        <h3 className="sec_ttl fadeup">
                            <span className="en">THE 4 NATIONS</span>
                            <span className="jp">{LanguageUtils.getLanguageData().story_4nations}</span>
                        </h3>
                        <ul className="anc_list fadeup">
                            <li><a href="#peaceful"><img src={`../assets/img/story/${LanguageUtils.getLanguage()}/nations_anc_peaceful.png`} alt="PEACEFUL［ピースフル］" width="310" height="280"/></a></li>
                            <li><a href="#brave"><img src={`../assets/img/story/${LanguageUtils.getLanguage()}/nations_anc_brave.png`} alt="BRAVE［ブレイブ］" width="310" height="280"/></a></li>
                            <li><a href="#freedom"><img src={`../assets/img/story/${LanguageUtils.getLanguage()}/nations_anc_freedom.png`} alt="FREEDOM［フリーダム］" width="310" height="280"/></a></li>
                            <li><a href="#glory"><img src={`../assets/img/story/${LanguageUtils.getLanguage()}/nations_anc_glory.png`} alt="GLORY［グローリー］" width="310" height="280"/></a></li>
                        </ul>
                    </div>
                    <div id="peaceful" className="nation_area peaceful_area">
                        <div className="bg_wrap">
                            <div className="bg_en"><img src="../assets/img/story/common/nations_peaceful_bg_en.png" alt="Land of the Peace" width="837" height="357"/></div>
                            <div className="bg_illust"></div>
                            <div className="flag_txt_grid">
                                <div className="flag"><img src="../assets/img/story/common/nations_peaceful_flag.jpg" alt="" width="668" height="445"/></div>
                                <div className="ttl_txt_wrap">
                                    <h4 className="ttl_nations">
                                        <span className="en">{LanguageUtils.getLanguageData().story_peaceful_main}</span>
                                        <span className="jp">{LanguageUtils.getLanguageData().story_peaceful_sub}</span>
                                    </h4>
                                    <p className="txt" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_peaceful_text}}></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="brave" className="nation_area brave_area">
                        <div className="bg_wrap">
                            <div className="bg_en"><img src="../assets/img/story/common/nations_brave_bg_en.png" alt="Land of the Brave" width="807" height="320"/></div>
                            <div className="bg_illust"></div>
                            <div className="flag_txt_grid">
                                <div className="flag"><img src="../assets/img/story/common/nations_brave_flag.jpg" alt="" width="668" height="445"/></div>
                                <div className="ttl_txt_wrap">
                                    <h4 className="ttl_nations">
                                        <span className="en">{LanguageUtils.getLanguageData().story_brave_main}</span>
                                        <span className="jp">{LanguageUtils.getLanguageData().story_brave_sub}</span>
                                    </h4>
                                    <p className="txt" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_brave_text}}></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="freedom" className="nation_area freedom_area">
                        <div className="bg_wrap">
                            <div className="bg_en"><img src="../assets/img/story/common/nations_freedom_bg_en.png" alt="Land of the Freedom" width="1024" height="344"/></div>
                            <div className="bg_illust"></div>
                            <div className="flag_txt_grid">
                                <div className="flag"><img src="../assets/img/story/common/nations_freedom_flag.jpg" alt="" width="668" height="445"/></div>
                                <div className="ttl_txt_wrap">
                                    <h4 className="ttl_nations">
                                        <span className="en">{LanguageUtils.getLanguageData().story_freedom_main}</span>
                                        <span className="jp">{LanguageUtils.getLanguageData().story_freedom_sub}</span>
                                    </h4>
                                    <p className="txt" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_freedom_text}}></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="glory" className="nation_area glory_area">
                        <div className="bg_wrap">
                            <div className="bg_en"><img src="../assets/img/story/common/nations_glory_bg_en.png" alt="Land of the Glory" width="762" height="337"/></div>
                            <div className="bg_illust"></div>
                            <div className="flag_txt_grid">
                                <div className="flag"><img src="../assets/img/story/common/nations_glory_flag.jpg" alt="" width="668" height="445"/></div>
                                <div className="ttl_txt_wrap">
                                    <h4 className="ttl_nations">
                                        <span className="en">{LanguageUtils.getLanguageData().story_glory_main}</span>
                                        <span className="jp">{LanguageUtils.getLanguageData().story_glory_sub}</span>
                                    </h4>
                                    <p className="txt" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_glory_text}}></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {
                    // 日本語のみHistory表示あり
                    LanguageUtils.getLanguage() == "ja" ? (
                        <section className="history_area">
                            <h3 className="sec_ttl fadeup">
                                <span className="en">HISTORY</span>
                                <span className="jp">{LanguageUtils.getLanguageData().story_history}</span>
                            </h3>
                            <div className="slide_wrap fadeup">
                                <div className="swiper">
                                    <div className="swiper-wrapper">
                                        <div className="swiper-slide">
                                            <div className="img"><img src="../assets/img/story/common/history_img01.jpg" alt="" width="700" height="493"/></div>
                                            <h4 className="ttl_gritty">{LanguageUtils.getLanguageData().story_history_title1}</h4>
                                            <p className="txt" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_history_text1}}></p>
                                        </div>
                                        <div className="swiper-slide">
                                            <div className="img"><img src="../assets/img/story/common/history_img02.jpg" alt="" width="700" height="493"/></div>
                                            <h4 className="ttl_gritty">{LanguageUtils.getLanguageData().story_history_title2}</h4>
                                            <p className="txt" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_history_text2}}></p>
                                        </div>
                                        <div className="swiper-slide">
                                            <div className="img"><img src="../assets/img/story/common/history_img03.jpg" alt="" width="700" height="493"/></div>
                                            <h4 className="ttl_gritty">{LanguageUtils.getLanguageData().story_history_title3}</h4>
                                            <p className="txt" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_history_text3}}></p>
                                        </div>
                                        <div className="swiper-slide">
                                            <div className="img"><img src="../assets/img/story/common/history_img04.jpg" alt="" width="700" height="493"/></div>
                                            <h4 className="ttl_gritty">{LanguageUtils.getLanguageData().story_history_title4}</h4>
                                            <p className="txt" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_history_text4}}></p>
                                        </div>
                                        <div className="swiper-slide">
                                            <div className="img"><img src="../assets/img/story/common/history_img05.jpg" alt="" width="700" height="493"/></div>
                                            <h4 className="ttl_gritty">{LanguageUtils.getLanguageData().story_history_title5}</h4>
                                            <p className="txt" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_history_text5}}></p>
                                        </div>
                                        <div className="swiper-slide">
                                            <div className="img"><img src="../assets/img/story/common/history_img06.jpg" alt="" width="700" height="493"/></div>
                                            <h4 className="ttl_gritty">{LanguageUtils.getLanguageData().story_history_title6}</h4>
                                            <p className="txt" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_history_text6}}></p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="swiper-button-next"></div>
                                    <div className="swiper-button-prev"></div>
                                    <div className="swiper-pagination"></div>

                                    <div className="btn_hexagon">
                                        <a href="../contents/novels/contentS1.html">{LanguageUtils.getLanguageData().story_goto_novel}</a>
                                    </div>
                                </div>
                            </div>
                        </section>
                    ) : (<></>)
                }
                <section className="glossary_area">
                    <div className="compass_wrap">
                        <p className="bg_compass"><img src="../assets/img/bg_compass_anime.svg" alt="" width="6058" height="6058"/></p>
                    </div>
                    <h3 className="sec_ttl fadeup">
                        <span className="en">GLOSSARY</span>
                        <span className="jp">{LanguageUtils.getLanguageData().story_glossary}</span>
                    </h3>
                    <ul className="glossary_list">
                        <li className="fadeup">
                            <dl>
                                <dt>{LanguageUtils.getLanguageData().story_glossary_title_zircon}</dt>
                                <dd dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_glossary_text_zircon}}></dd>
                            </dl>
                        </li>
                        <li className="fadeup">
                            <dl>
                                <dt>{LanguageUtils.getLanguageData().story_glossary_title_zirpower}</dt>
                                <dd dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_glossary_text_zirpower}}></dd>
                            </dl>
                        </li>
                        <li className="fadeup">
                            <dl>
                                <dt>{LanguageUtils.getLanguageData().story_glossary_title_zirgear}</dt>
                                <dd dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_glossary_text_zirgear}}></dd>
                            </dl>
                        </li>
                        <li className="fadeup">
                            <dl>
                                <dt>{LanguageUtils.getLanguageData().story_glossary_title_relic}</dt>
                                <dd dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().story_glossary_text_relic}}></dd>
                            </dl>
                        </li>
                    </ul>
                </section>
            </main>
            <footer id="incFt"></footer>
        </div>
    </>
    );
};

export default View;